// import IS_TEST from "./IsTest";

export const API_BASE_URL = 'https://api.tmxmessenger.com';
export const SIGNUP_API_BASE_URL = 'https://vajrozyb08.execute-api.us-west-2.amazonaws.com/dev/'; //prod

//endpoints
export const GET_BIO_INFO_URL = API_BASE_URL + 'messenger-signup';
export const SIGN_IN = API_BASE_URL;
export const CHAT = API_BASE_URL + '/chat';
export const GET_CONVERSATION = API_BASE_URL + '/getConversation';
export const GET_RECENT_USER_CONVERSATION_ID = API_BASE_URL + '/getRecentUserConversationId';
export const ANALYTICS_DASHBOARD = API_BASE_URL + '/activity';

export const SET_BIO_INFO_URL = SIGNUP_API_BASE_URL + 'messenger-signup';

export const PERSON_SEARCH_URL = API_BASE_URL + '/api/people/search';

export const FTU_COMPLETE_URL = API_BASE_URL;

export const ANALYTICS_DATA_DAY = API_BASE_URL + '/api/v1/kpis/latest';
export const ANALYTICS_DATA_WEEK = API_BASE_URL + '/api/v1/kpis/weekly';
export const ANALYTICS_DATA_MONTH = API_BASE_URL + '/api/v1/kpis/monthly';
